module.exports = __webpack_public_path__ + "media/src/images/certificates/milestone_completed-5262ac2954014e1128a5b800030f9fa1.png";